module.exports = __webpack_public_path__ + "static/media/top__title.9d995f0c.png";